module.exports = __webpack_public_path__ + "static/media/instructions_2.083ba313.svg";